import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

export class Api {
    constructor() {}

    get(uri) {
        const url = `${API_URL}${uri}`
        axios.defaults.headers.common['Authorization'] = localStorage.token

        return axios
            .get(url)
            .then((response) => response.data)
            .catch((error) => error)
    }

    post(uri, params = {}) {
        const url = `${API_URL}${uri}`
        axios.defaults.headers.common['Authorization'] = localStorage.token

        const oParams = new URLSearchParams()

        Object.keys(params).forEach((key) => {
            const value = params[key]

            if (value === undefined || value === null) return

            if (Array.isArray(value)) {
                oParams.append(key, value.join(','))
                return
            }

            if (typeof value === 'boolean') {
                oParams.append(key, value ? '1' : '0')
                return
            }

            oParams.append(key, String(value))
        })

        const config = {}

        if (uri !== 'admin/login') {
            config.timeout = 10000
        }

        return axios
            .post(url, oParams, config)
            .then((response) => response.data)
            .catch((error) => error)
    }

    language(lang) {
        const url = `${API_URL}lang/${lang}`
        return axios
            .get(url, {
                validateStatus: function (status) {
                    return status
                }
            })
            .then((response) => response.data)
    }
}
